import request from '@/utils/request'

export function findAgentsCpeProducts(params) {
  return request({
    url: `/agents_cpe_products`,
    method: 'get',
    params
  })
}

export function importAgentsCpeProducts(data) {
  return request({
    url: `/agents_cpe_products/import`,
    method: 'post',
    data
  })
}

export function findAgentsCpeProductForm(id) {
  return request({
    url: `/agents_cpe_products/${id}/form`,
    method: 'get'
  })
}

export function updateAgentsCpeProduct(id, data) {
  return request({
    url: `/agents_cpe_products/${id}`,
    method: 'put',
    data
  })
}

export function batchUpdateAgentsCpeProductsEffective(ids, effective) {
  return request({
    url: `/agents_cpe_products/effective/batch`,
    method: 'patch',
    data: { ids, effective }
  })
}
